import { AREA_LIST_NO_ALL } from '@/pages/chargermap/components/wishpower/config/area'
import { AREA_LIST } from '@/pages/chargermap/config/area'
import { CITY_MAP } from '@/pages/chargermap/config/gis'

/**
 * 根据城市简称获取城市信息
 * @param {string} simple 城市简称
 * @returns {CityInfo} 城市信息
 */
export const getCityInfo = (simple: string) => {
  const info = CITY_MAP[simple]
  if (info) {
    info.simple = simple
    return info
  }
}

/**
 * 根据城市名称获取省市信息
 * @param {string} simple 城市简称
 * @returns {CityInfo} 省市信息
 */
export const getAreaInfoByName = (name: string) => {
  for (const province of AREA_LIST) {
    if (province.name === name) {
      return province
    }
    if (province.cities) {
      for (const city of province.cities) {
        if (city.name === name) {
          return city
        }
        if (city.districts) {
          for (const district of city.districts) {
            if (district.name === name) {
              return district
            }
          }
        }
      }
    }
  }
}

/**
 * 根据城市名称获取省市信息
 * @param {string} simple 城市简称
 * @returns {CityInfo} 省市信息
 */
export const getAreaInfoByNameArr = (names: string[]) => {
  // 省市区县一直匹配下去
  let index = 0
  const lenIndex = names.length - 1
  if (names[0] == '全国') {
    return AREA_LIST[0]
  }
  for (const province of AREA_LIST) {
    if (province.name === names[index]) {
      if (index == lenIndex) {
        return province
      } else {
        index++
        if (province.cities) {
          for (const city of province.cities) {
            if (city.name === names[index]) {
              if (index == lenIndex) {
                return city
              } else {
                index++
                if (city.districts) {
                  for (const district of city.districts) {
                    // if (district.name === names[index]) {
                    if (district.name.indexOf(names[index]) > -1) {
                      if (index == lenIndex) {
                        return district
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

/**
 * 根据城市名称获取省市信息
 * @param {string} simple 城市简称
 * @returns {CityInfo} 省市信息
 */
export const getAreaInfoByNameWishPower = (name: string) => {
  for (const province of AREA_LIST_NO_ALL) {
    if (province.name === name) {
      return province
    }
    if (province.cities) {
      for (const city of province.cities) {
        if (city.name === name) {
          return city
        }
        if (city.districts) {
          for (const district of city.districts) {
            if (district.name === name) {
              return district
            }
          }
        }
      }
    }
  }
}

/**
 * 根据城市名称获取城市信息
 * @param {string} simple 城市简称
 * @returns {CityInfo} 城市信息
 */
export const getCityInfoByName = (name: string) => {
  const area = getAreaInfoByName(name)
  if (area) {
    return getCityInfo(area.simple)
  }
}

/**
 * 根据城市名称获取城市信息
 * @param {string} simple 城市简称
 * @returns {CityInfo} 城市信息
 */
export const getCityInfoByNameArr = (names: string[]) => {
  const area = getAreaInfoByNameArr(names)
  if (area) {
    return getCityInfo(area.simple)
  }
}

/**
 * 根据城市名称获取城市信息
 * @param {string} simple 城市简称
 * @returns {CityInfo} 城市信息
 */
export const getCityInfoByNameWishPower = (name: string) => {
  const area = getAreaInfoByNameWishPower(name)
  if (area) {
    return getCityInfo(area.simple)
  }
}
